import { rem } from 'polished';
import React, { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getChannel, isTelusTheme } from 'utils/getChannel';
import UnmindLogo from '../Shared/Assets/unmind_logo_with_name.svg';
import TelusLogo from '../Shared/Assets/telus_logo.svg';

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  width: 100%;
  padding: 0 0 0 ${rem(10)};
`;

const LogoImage = styled.img<{ isTelus: boolean }>`
  width: ${({ isTelus }) => rem(isTelus ? 180 : 100)};
  height: auto;
`;

export const Logo = ({
  headerLogoRef,
}: {
  headerLogoRef?: RefObject<HTMLAnchorElement>;
}) => {
  const { t: translate } = useTranslation('shared');

  const isTelus = isTelusTheme();
  const logoSrc = isTelus ? TelusLogo : UnmindLogo;
  const altText = isTelus
    ? `${getChannel().brandName}`
    : translate('navigation.unauthenticated_header_logo.alt_text');

  return (
    <StyledLink to={'/home'} ref={headerLogoRef}>
      <LogoImage src={logoSrc} alt={altText} isTelus={isTelus} />
    </StyledLink>
  );
};
